import React from 'react';
import style from './index.module.css';
import { welcomeSection } from '../../assets/constants';
import { Link } from 'react-router-dom';
import { getImage } from '../../utils/utils';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';

const AboutUsSection = (props) => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';

	return (
		<motion.div 
			initial={{ opacity: 0, x: -50 }}
			whileInView={{ opacity: 1, x: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.8 }}
			className={style.aboutContainer}
			style={{
				backgroundColor: isDark ? 'rgba(124, 77, 255, 0.1)' : theme.palette.primary.main,
				color: '#fff',
			}}
		>
			<div className={style.welcomeTextSection}>
				<div className={style.textContent}>
					<motion.p 
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						className={style.subHeader}
					>
						ABOUT US
					</motion.p>
					<h1 className={style.welcomeText}>
						{welcomeSection.header}
					</h1>
					<p className={style.descriptionText}>
						{welcomeSection.content}
					</p>
					{props.showMore && (
						<motion.div 
							whileHover={{ scale: 1.05 }}
							whileTap={{ scale: 0.95 }}
							style={{ padding: '2rem 0' }}
						>
							<Link className={style.link} to={'/about_us'}>
								{'Discover Our Story'}
							</Link>
						</motion.div>
					)}
				</div>
				<motion.div 
					whileHover={{ rotate: 5, scale: 1.05 }}
					className={style.imageContainer}
				>
					<img
						className={style.borderImage}
						src={getImage('image11')}
						alt='About us'
					/>
				</motion.div>
			</div>
		</motion.div>
	);
};

export default AboutUsSection;
